export default __webpack_public_path__ + "02de4d00619fbcacf341e6b700bfa1a8.png";